import { useAuth } from "@clerk/clerk-react";
import { useToolPrepDownloadFlow } from "./useToolPrepDownloadFlow";

/**
 * AI / transform tool download: Options (format + filename) → Thank You.
 * No quality row (variant "ai").
 */
export function useToolPrepImageDownload(imageUrl, fileName, options = {}) {
  const {
    onError,
    enabled = true,
    fallbackName = "image.png",
    variant = "ai",
    toolKey = "",
    shareTitle = "LazyStudio",
    shareText = "I edited my photo with LazyStudio!",
    thankYouCopy = {},
  } = options;

  const { getToken } = useAuth();

  const downloadFlow = useToolPrepDownloadFlow({
    variant,
    sourceFileName: fileName,
    fallbackDownloadName: fallbackName,
    getToken,
    toolKey,
    shareTitle,
    shareText,
    thankYouCopy,
  });

  const handleDownload = async () => {
    if (!imageUrl) return;
    try {
      await downloadFlow.openDownloadOptions({
        previewUrl: imageUrl,
        resolveImageUrl: async () => imageUrl,
      });
    } catch (err) {
      const message = err?.message || "Could not download image.";
      if (typeof onError === "function") onError(message);
      else alert(message);
    }
  };

  return {
    downloadBusy: downloadFlow.downloadBusy,
    onDownload: enabled && imageUrl ? handleDownload : undefined,
    downloadFlow,
  };
}
